import Vue from "vue";
import moment from "moment";

export default {
	components: {},
	data: function() {
		return {
			items: [],
			isInEditMode: false,
			hasSelectedMode: false,
			hasEditableMode: false,

			itemSelected: null,

			skip: 0,
			take: 25,
			total: 0,

			currentPage: 1,
			hasNextPage: false,
			hasPreviousPage: false,
			nextIndex: 1,
			nextPage: 2,
			previousIndex: 0,
			previousPage: 1,
			totalCount: 0,
			totalIndex: 0,
			totalPages: 0,

			pageable: {
				buttonCount: 5,
				info: true,
				type: "numeric",
				pageSizes: false,
				previousNext: true
			},
			query: {
				page: 0,
				pageSize: 25,
				sort: "",
				sortDirection: ""
			},
			columnFilters: [
				// {
				// 	field: "",
				// 	filter: {
				// 		logic: "or",
				// 		filters: []
				// 	}
				// }
			],

			columnsToShow: [],
			sort: null,

			updatedItems: [],
			createdItems: [],
			deletedItems: [],

			indexNewItem: 0,
			defaultAddRow: null,

			selectedField: "selected",

			itemToReturnIfIsInEditMode: []
		};
	},
	watch: {
		sort: {
			handler(val) {
				if (this.sort) {
					this.query.sort = "";
					for (var i = 0; i < this.sort.length; i++) {
						var sf = this.sort[i];
						this.query.sort += `${sf.field}|${sf.dir},`;
					}

					this.query.sort = this.query.sort.substring(0, this.query.sort.length - 1);
				} else {
					this.query.sort = "";
					this.query.sortDirection = "";
				}

				this.getData();
			},
			deep: true
		}
	},
	methods: {
		addItem() {
			if (!this.isInEditMode) return;

			this.createdItems.push(this.defaultAddRow);
			this.items.unshift(this.defaultAddRow);
			this.indexNewItem--;
		},
		remove(e) {
			if (!this.isInEditMode) return;

			if (e.dataItem.id <= 0) {
				var newItemIndex = this.createdItems.findIndex(function(item) {
					return item.id === e.dataItem.id;
				});

				this.createdItems.splice(newItemIndex, 1);
			} else {
				var itemToRemove = this.items.find(function(it) {
					return it.id === e.dataItem.id;
				});
				this.deletedItems.push(itemToRemove);
				var itemIndexUpdatedToRemove = this.updatedItems.findIndex(function(it) {
					return it.id === e.dataItem.id;
				});
				if (itemIndexUpdatedToRemove >= 0) {
					this.updatedItems.splice(newItemIndex, 1);
				}
			}

			var itemIndex = this.items.findIndex(function(item) {
				return item.id === e.dataItem.id;
			});
			this.items.splice(itemIndex, 1);
		},
		itemChange: function(e) {
			Vue.set(e.dataItem, e.field, e.value);

			var item = this.items.find(function(it) {
				return it.id === e.dataItem.id;
			});

			if (e.dataItem.id > 0) this.updatedItems.push(item);

			this.changes = true;
		},
		clearWorkingData() {
			this.createdItems = [];
			this.updatedItems = [];
			this.deletedItems = [];

			this.isInEditMode = false;
		},
		removeFilter(e) {
			if (e) {
				var findFilterIndex = this.columnFilters.findIndex(function(item) {
					return item.field === e.field;
				});

				this.columnFilters.splice(findFilterIndex, 1);

				if (this.internalFiltersToUpdate) {
					this.internalFiltersToUpdate(e);
				}

				if (this.getData)
					this.getData();
			}
		},
		filterHandler(e) {
			if (e) {
				var findFilterIndex = this.columnFilters.findIndex(function(item) {
					return item.field === e.field;
				});

				if (findFilterIndex >= 0) {
					this.columnFilters.splice(findFilterIndex, 1);
				}

				if (e.filterType == "multiselect" && e.filterItemsSelected.length > 0) {
					var filtersToAdd = {
						field: e.field,
						type: "multiselect",
						filter: {
							logic: "or",
							filters: []
						}
					};

					for (var i = 0; i < e.filterItemsSelected.length; i++) {
						var f = e.filterItemsSelected[i];
						filtersToAdd.filter.filters.push({
							field: `${e.field}[${i}]`,
							operator: "contains",
							value: f
						});
					}

					this.columnFilters.push(filtersToAdd);
				} else if (e.filterType == "datetimerange" || e.filterType == "daterange") {
					this.columnFilters.push({
						field: e.field,
						type: "datetime",
						filter: {
							logic: "and",
							filters: [
								{
									field: `${e.field}_start`,
									operator: "gte",
									value: e.startDateHeader ? moment(e.startDateHeader).utc().format() : null
								},
								{
									field: `${e.field}_end`,
									operator: "lte",
									value: e.endDateHeader ? moment(e.endDateHeader).endOf("day").utc().format() : null
								}
							]
						}
					});
				} else if (e.filterType == "boolean") {
					this.columnFilters.push({
						field: e.field,
						type: "boolean",
						filter: {
							logic: "and",
							filters: [
								{
									field: e.field,
									operator: "eq",
									value: e.filterRadioButtonSelected
								}
							]
						}
					});
				} else if (e.filterText) {
					this.columnFilters.push({
						field: e.field,
						type: "text",
						filter: {
							logic: "and",
							filters: [
								{
									field: e.field,
									operator: "contains",
									value: e.filterText
								}
							]
						}
					});
				} else {
					this.removeFilter(e);
				}

				if (this.getData)
					this.getData();
			}
		},
		headerClick: function(e) {
			if (this.sort && this.sort.length > 0) {
				var existFieldSorted = this.sort.find(function(f) {
					return f.field == e.field
				});
				if (existFieldSorted) {
					if (existFieldSorted.dir == "asc") {
						existFieldSorted.dir = "desc";
					} else if (existFieldSorted.dir == "desc") {
						var findIndexOfField = this.sort.findIndex(function(f) {
							return f.field == e.field
						});
						this.sort.splice(findIndexOfField, 1);
					} 
				}
				else {
					this.sort.push({field: e.field, dir: "asc"});
				}
			}
			else {
				this.sort = [{field: e.field, dir: "asc"}];
			}

			// if (this.sortChangeHandler)
			// 	this.sortChangeHandler();
		},
		switchEditMode() {
			this.isInEditMode = !this.isInEditMode;

			if (!this.isInEditMode) {
				this.clearWorkingData();
				this.getData();
			}
		},
		selectRow(dataItem) {
			this.items.forEach(d => {
				if (d.selected) {
					Vue.set(d, "selected", undefined);
				}
			});

			if (!this.isInEditMode && this.hasSelectedMode) {
				//Selected Mode
				Vue.set(dataItem, this.selectedField, !dataItem[this.selectedField]);
				dataItem.id;
			}
		},
		onRowClick: function(e) {
			if (this.hasSelectedMode) {
				this.selectRow(e.dataItem);
				this.$emit("selected-row", e.dataItem);
			}
		},
		cellClickHandler: function(e) {
			var columnField = this.columnsToShow.find(function(f) {
				return f.field === e.field;
			});

			this.items.forEach(d => {
				if (d.selected) {
					Vue.set(d, "selected", undefined);
				}
			});

			if (!this.isInEditMode && this.hasSelectedMode) {
				//Selected Mode
				Vue.set(e.dataItem, "selected", e.field);
				e.dataItem.id;
			} else if (this.isInEditMode && this.hasEditableMode) {
				if (e.dataItem.inEdit && e.field === this.editField) {
					return;
				}

				if (columnField && columnField.editable) {
					this.editField = e.field;
					this.items = this.items;

					Vue.set(e.dataItem, "inEdit", e.field);

					this.items.forEach(d => {
						if (d.inEdit) {
							if (e.dataItem !== d) {
								Vue.set(d, "inEdit", undefined);
							}
						}
					});
					this.items = this.items;
				}
			}
			if (!this.isInEditMode && columnField.format == 'link') {
				if (this.goTo) {
					this.goTo(e.dataItem);
				}
			}
		}
	},
	computed: {
		gridData() {
			return this.items;
		}
	}
};
